import { render, staticRenderFns } from "./PublicNotice.vue?vue&type=template&id=c1aa577c&scoped=true"
import script from "./PublicNotice.vue?vue&type=script&lang=js"
export * from "./PublicNotice.vue?vue&type=script&lang=js"
import style0 from "./PublicNotice.vue?vue&type=style&index=0&id=c1aa577c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1aa577c",
  null
  
)

export default component.exports